import React, { useContext, useEffect, useState, useRef, useMemo } from "react";
import { Typography, Box, Grid } from '@mui/material';

const PrivacyPolicyPage = () => {
    return (
        <>
            <Box sx={{ flexGrow: 1, p: 2 }}>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 12 }}>
                        <Typography variant="body1">
<section id="privacy-policy">
  <h1>Privacy Policy</h1>
  <p><strong>Effective Date:</strong> May 1, 2025</p>

  <p>At GGClive.com, we respect your privacy and are committed to protecting your personal information. This Privacy Policy describes how we collect, use, and safeguard your data.</p>

  <h2>Information We Collect</h2>
  <ul>
    <li><strong>Account Info:</strong> Name, email, and profile details you provide</li>
    <li><strong>Payments:</strong> 
      <ul>
        <li><strong>iOS Subscriptions & Tips:</strong> Processed securely through Apple’s in‑app purchase system. We do not receive your full payment details.</li>
        <li><strong>Web Payments:</strong> Handled securely by Stripe. Stripe may collect limited billing information as required to process payments.</li>
      </ul>
    </li>
    <li><strong>Usage Data:</strong> IP address, device info, browser type, and pages visited</li>
    <li><strong>Cookies:</strong> Used for analytics and personalized content. You can manage these in your browser settings</li>
  </ul>

  <h2>How We Use Your Info</h2>
  <ul>
    <li>To manage your account and process payments</li>
    <li>To improve your experience and respond to support requests</li>
    <li>To deliver app updates and communicate promotions (with your permission)</li>
    <li>To comply with legal obligations and prevent fraud</li>
  </ul>

  <h2>Payments & Tips</h2>
  <p><strong>iOS subscriptions and tips are processed exclusively through Apple’s in‑app purchase system.</strong> For web‑based purchases, we use Stripe as our secure payment processor. We do not store or have access to your full payment details.</p>

  <h2>Sharing & Disclosure</h2>
  <ul>
    <li>We may share data with trusted vendors and legal authorities if required</li>
    <li>We do not sell or rent your personal data</li>
  </ul>

  <h2>Your Rights</h2>
  <ul>
    <li>Access, correct, or delete your account data by contacting us</li>
    <li>Adjust cookie settings</li>
    <li>Opt out of marketing emails</li>
    <li>Request a copy of your personal data</li>
  </ul>

  <h2>Data Retention</h2>
  <p>We only keep your data as long as necessary for service delivery and legal compliance. Then it’s securely deleted or anonymized.</p>

  <h2>GDPR & CCPA</h2>
  <p>EU users have rights to access, rectify, or delete their data. California residents can request information, deletion, or opt out of data sale (<em>GGClive.com does not sell data</em>).</p>

  <h2>Security</h2>
  <p>We use industry-standard practices to protect data, though no method is 100% secure.</p>

  <h2>Third-Party Services</h2>
  <p>GGClive.com may link to or integrate with third-party tools such as Stripe or Apple. We encourage reviewing their privacy policies directly.</p>

  <h2>Policy Updates</h2>
  <p>We may revise this Privacy Policy. Updates will be posted on this page with a new effective date.</p>

  <h2>Contact Us</h2>
  <p>Questions? Please contact us at <a href="mailto:info@ggclive.com">info@ggclive.com</a></p>
</section>
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: 12 }}>

                    </Grid>
                </Grid>
            </Box>
        </>
    )
}
export default PrivacyPolicyPage;